// 全局指令
export const inputInserted = {
  // inputInserted  当被绑定的元素插入到 DOM 中时……
  // componentUpdated 指令所在组件的 VNode 及其子 VNode 全部更新后调用
  componentUpdated: function (el, binding, vnode) {
    if (vnode.context.form[binding.value]) {
      vnode.context.$refs.form.validateField(binding.value)
    };
  }
}